//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import { ReactComponent as Arrow } from "../../../../Media/Icon/002.svg";

//Element
class Worldwide extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB h01g8q d-none" },
            //Element
            React.createElement(Container, {},
                //Element
                React.createElement(Row, {},
                    //Element
                    React.createElement(Col, { md: 12 },
                        //Element
                        React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB v34370" },
                            //Element
                            React.createElement("ul", { className: "S6pt64 C96Q4r pEO064 a527eB c5207d" },
                                //Element
                                React.createElement("li", { className: "S6pt64 C96Q4r" },
                                    //Element
                                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/" },
                                        //Element
                                        "Türkiye",
                                        //Element
                                        React.createElement(Arrow, {})
                                    )
                                ),
                                //Element
                                React.createElement("li", { className: "S6pt64 C96Q4r" },
                                    //Element
                                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "/en" },
                                        //Element
                                        "United Kingdom",
                                        //Element
                                        React.createElement(Arrow, {})
                                    )
                                ),
                                //Element
                                React.createElement("li", { className: "S6pt64 C96Q4r d-none" },
                                    //Element
                                    React.createElement("a", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB", href: "https://temaselektrik.az/" },
                                        //Element
                                        "Azerbaijan",
                                        //Element
                                        React.createElement(Arrow, {})
                                    )
                                )
                            )
                        )
                    )
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Worldwide;